import { AgGridReact } from '@ag-grid-community/react';
import React from 'react';
import { TableWrapper } from './AgGridTable.styles';

const AgGridTable = ({ gridStyle, gridOptions }) => {
	return (
		<TableWrapper>
			<div style={gridStyle} className="ag-theme-balham">
				<AgGridReact {...gridOptions} />
			</div>
		</TableWrapper>
	);
};

export default AgGridTable;
